import { Link } from "@inertiajs/react"

import { ListsSidebar } from "@/components/lists-sidebar"
import { NavFooter } from "@/components/nav-footer"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "@/components/ui/sidebar"
import { FOOTER_NAVIGATION_ITEMS } from "@/config/navigation"
import { useNavigationPermissions } from "@/hooks/use-navigation-permissions"
import { rootPath } from "@/routes"

import AppLogo from "./app-logo"

export function AppSidebar() {
  const { filterNavigationItems } = useNavigationPermissions()
  const footerItems = filterNavigationItems(FOOTER_NAVIGATION_ITEMS)

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={rootPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <ListsSidebar />
      </SidebarContent>

      <SidebarFooter>
        {footerItems.length > 0 && (
          <>
            <SidebarSeparator />
            <NavFooter items={footerItems} />
          </>
        )}
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
